import React from "react";
import { Helmet } from "react-helmet";
import { Box, Container } from "@mui/material";
import CloudLabList from "../../components/labstructure/Cloudlabs/LabList";

const Labs = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <CloudLabList />
        </Container>
      </Box>
    </React.Fragment>
  );
};

export default Labs;